export function translatePaymentStatus(status: string): string {
  switch (status) {
    case 'PAID':
      return 'Opłacona';
    case 'FAILED':
      return 'Nieudana';
    case 'CANCELLED':
      return 'Anulowana';
    case 'PENDING':
      return 'W trakcie';
    case 'REFUNDED':
      return 'Zwrócona';
    default:
      return status;
  }
}
